
// export const checkIsNetworkEnabledForDoorKey = (door_key_type, platform)=>{
 
//     let isEnabled=false;
//     if(platform=="Android" ){
//         console.log(door_key_type, "door_key_type")
//         switch(door_key_type){
//             case "AA":
//                 console.log("aa", window.assaabloy.isNetworkEnabled())
//                 isEnabled= Boolean(window.assaabloy && window.assaabloy.isNetworkEnabled());
//                 break;
//             case "DK":
//                 isEnabled= Boolean( window.dormakaba && window.dormakaba.isNetworkEnabled());
//                 break;
//             case "SALTO":
//                 console.log("salto", window.assaabloy.isNetworkEnabled())
//                 isEnabled= Boolean(window.salto && window.salto.isNetworkEnabled());
//                 break;
//         }
//     } else {
//         switch(door_key_type){
//             case "AA":
//                 if (window.cordova && window.cordova.plugins && window.cordova.plugins.AssaAbloy) {
//                     window.cordova.plugins.AssaAbloy.isNetworkEnabled(
//                         "hello", ()=>{isEnabled=true;}, ()=> {isEnabled=false;}
//                     )
//                 }
//                 break;
//             case "DK":
//                 if (window.cordova && window.cordova.plugins && window.cordova.plugins.Dormakaba) {
//                     window.cordova.plugins.Dormakaba.isNetworkEnabled(
//                         "hello", ()=>{isEnabled=true;},  ()=> {isEnabled=false;}
//                     )
//                 }
//                 break;
//             case "SALTO":
//                 if (window.cordova && window.cordova.plugins && window.cordova.plugins.Salto) {
//                     window.cordova.plugins.Salto.isNetworkEnabled(
//                         "hello", ()=>{isEnabled=true;},  ()=> {isEnabled=false;}
//                     )
//                 }
//                 break;
//         }
//     }

//     return isEnabled;
// }

// export const checkIsBluetoothEnabledForDoorKey = (door_key_type, platform)=>{

//     let isEnabled=false;
//     if(platform=="Android" ){
//         switch(door_key_type){
//             case "AA":
//                 isEnabled= Boolean(window.assaabloy && window.assaabloy.isBluetoothEnabled());
//                 break;
//             case "DK":
//                 isEnabled= Boolean( window.dormakaba && window.dormakaba.isBluetoothEnabled());
//                 break;
//             case "SALTO":
//                 isEnabled= Boolean(window.salto && window.salto.isBluetoothEnabled());
//                 break;
//         }
//     } else {
//         switch(door_key_type){
//             case "AA":
//                 if (window.cordova && window.cordova.plugins && window.cordova.plugins.AssaAbloy) {
//                     window.cordova.plugins.AssaAbloy.isBluetoothEnabled(
//                         "hello", ()=>{isEnabled=true;}, ()=> {isEnabled=false;}
//                     )
//                 }
//                 break;
//             case "DK":
//                 if (window.cordova && window.cordova.plugins && window.cordova.plugins.Dormakaba) {
//                     window.cordova.plugins.Dormakaba.isBluetoothEnabled(
//                         "hello", ()=>{isEnabled=true;},  ()=> {isEnabled=false;}
//                     )
//                 }
//                 break;
//             case "SALTO":
//                 if (window.cordova && window.cordova.plugins && window.cordova.plugins.Salto) {
//                     window.cordova.plugins.Salto.isBluetoothEnabled(
//                         "hello", ()=>{isEnabled=true;},  ()=> {isEnabled=false;}
//                     )
//                 }
//                 break;
//         }
//     }

//     return isEnabled;
// }

export const checkIsBluetoothEnabledForDoorKey = () => {
    console.log("inside checkIsBluetoothEnabledForDoorKey")
    if (window.cordova && window.cordova.plugins && window.cordova.plugins.BluetoothStatus) {
        return Boolean(window.cordova.plugins.BluetoothStatus.BTenabled);
    }
    return false;
};
